import { CellDescriptions } from '@mpc/components'
import React from 'react'

/**
 * 合作项目
 */
const CooperationCell = ({
  record,
  mainPlatformQuoteItemOptions,
}) => {

  return (
    <CellDescriptions
      maxDisplayCount={4}
      column={1}
      items={[
        {
          label: '主平台官单/私单',
          children: mainPlatformQuoteItemOptions?.find(v => v.value === record.public_order)?.name || '--',
        },
        {
          label: '主平台报价项目',
          children: mainPlatformQuoteItemOptions?.find(v => v.value === record.main_platform_quote_item)?.name || '--',
        },
      ]}
    />
  )
}

export default CooperationCell
